<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        filled
        dense
        :append-icon="!disabled ? 'mdi-calendar-blank' : ''"
        readonly
        :disabled="disabled"
        v-on="on"
        @click:append="menu = true"
        :class="{ narrow: narrow }"
        :clearable="!!value"
        v-model="selected"
        value
        :rules="rules"
      >
      </v-text-field>
    </template>
    <v-date-picker
      :type="datePickerType"
      :value="value"
      ref="picker"
      v-on:input="updateValue($event)"
      :max="maxDate"
      :min="minDate"
      @input="menu = false"
    >
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  name: "DateField",
  props: {
    value: {
      type: String
    },
    maxDate: {
      type: String
      //defaults to 100 years in the future
    },
    minDate: {
      type: String
      //defaults to 100 years in the past
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    narrow: {
      type: Boolean
    },
    rules: {
      type: Array,
      default: () => []
    },
    monthPicker: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selected: {
      get() {
        return this.formatDate(this.value);
      },
      set(value) {
        this.updateValue(value);
      }
    },
    datePickerType() {
      return this.monthPicker ? "month" : "date";
    }
  },
  data() {
    return {
      menu: false
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    updateValue: function(value) {
      this.$emit("input", value);
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      let month = date.substring(5, 7);
      let dateSlash = this.monthPicker ? "" : `${date.substring(8, 10)}/`;
      let year = date.substring(0, 4);
      return `${month}/${dateSlash}${year}`;
    }
  }
};
</script>
<style scoped lang="sass">
.narrow
  max-width: 280px
</style>
